$(document).ready(function () {
    let offset = 0;
    const initialLoad = 5;
    const perScrollLoad = 3;
    let loading = false;
    $('#div_notificaciones').on('click', function(event){
        event.stopPropagation();
    });

    loadNotifications = function(count) {
        if (loading) {
            return; // Evita múltiples solicitudes mientras se está cargando
        }
        loading = true;
        $.ajax({
            url: `/getNotificaciones/${offset}/${count}`,
            type: 'GET',
            success: function (data) {
                loading = false;
                if (data.notificaciones.length > 0) {
                    offset = parseInt(offset) + parseInt(count);
                    $("#btn_cargar_mas_notificaciones").remove();
                    $("#btn_sin_notificaciones").remove();
                    appendNotifications(data);
                } else if(offset===0){
                    $('#div_notificaciones').append(`
                        <div class="dropdown-item d-flex align-items-center p-1" id="btn_sin_notificaciones">
                            <div class="btn btn-sm btn-link w-100">
                                <small>Sin notificaciones</small>
                            </div>
                        </div>`);
                }
            },
            error: function (xhr, status, error) {
                console.error(error);
            },
        });
    }

    leerNotificacion = function(e,id){
        let total = parseInt($("#total_notificaciones").html());
        if(total > 0){
            total--;
            $("#total_notificaciones").html(total);
            e.classList.remove('btn');
            e.classList.remove('btn-link');
            e.classList.remove('btn-sm');
            e.removeAttribute('onclick');
            e.innerHTML = `<small>Leída ${moment(new Date()).locale('es').fromNow()}</small>`;
            $.ajax({
                url: `/leerNotificacion/${id}`,
                type: 'GET',
                success: function (data) {
                },
                error: function (xhr, status, error) {
                    console.error(error);
                },
            });
        }

    }

    function appendNotifications(notifications) {

        const dropdown = $('#div_notificaciones');

        notifications.notificaciones.forEach((n) => {

            let accion = "";

            if(!n.vistas[0])

                accion = `<div class="row m-0">
                               <div class="btn btn-sm btn-link col-auto px-0" onclick="leerNotificacion(this, ${n.id})">
                                   <i class="fa fa-check fa-xs"></i>
                                   <small>Marcar como leída</small>
                               </div>
                           </div>`;
            else

                accion = `<div class="row m-0">
                               <div class="col-auto px-0">
                                   <small>Leída ${moment(n.vistas[0].created_at).locale('es').fromNow()}</small>
                               </div>
                           </div>`;

            const nElement = `<div class="dropdown-item d-flex align-items-center py-1">
                    <div>
                        <div class="small text-gray-500 small">${moment(n.created_at).locale('es').fromNow()}</div>
                        <span class="font-weight-bold small">${n.descripcion} </span>
                        <div class="row m-0">
                           <div class="col-auto px-0">
                                <a href="${n.url}" class="float-end"><small>${n.descripcion_url}</small></a>
                            </div>
                        </div>
                        ${accion}
                    </div>
                </div>`;

            dropdown.append(nElement);
        });

        dropdown.append(`
            <div class="dropdown-item d-flex align-items-center p-1" id="btn_cargar_mas_notificaciones">
                <div class="btn btn-sm btn-link w-100"  onclick="loadNotifications(${perScrollLoad})">
                                <small>${notifications.hay_mas ? 'Cargar más' : 'No hay más notificaciones'}</small>
                </div>
            </div>`);
    }

    if(document.getElementById('div_notificaciones'))
        loadNotifications(initialLoad);

});
